import React, { useContext, useState, useEffect, FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

// d.ts
import { IDataController, DCRecord } from "@/@types/lib/dataController"

// Custom Components
import ModelTable from "@/ui/Table/ModelTable";
import DialogContext from "@/ui/DialogContext/DialogContext";

import api from "@/lib/api";
import { downloadFile } from "@/lib/downloadFile";
import dataController from "@/lib/dataController";
import { DialogContextType } from "@/@types/ui/DialogContext";
import StatusDialog from "./ObjektiStatusDialog";

//Types
import { IModel } from "@/@types/models/model";
import KatoviDialog from "./KatoviDialog"
import modelKatovi from "@/models/katovi"
import modelDijelovi from "@/models/dijelovi"

// TODO:
// subModels cleanup: they are added to the project because Table.jsx can not function without them


interface IRadniSastanciObjectTableProps {
  records: Array<DCRecord>;
  onRowSelect: (id: number, record: DCRecord) => void;
  // onLoad?: (records: Array<DCRecord>) => void;
  lokacijaId?: number;
  selectedObjektId?: number;
  selectedLokacija: DCRecord | null;
  model: IModel;
  titleToken: string;
  rowSelectedCustom?: number;
  onSave: (text: string) => void;
  onCloseDialog: (result: { dataChanged: boolean; action: string }) => void;
  refreshRecords: () => void;
  statusFields?: DCRecord[];
}

let CHANGED_FLAG = false;

const RadniSastanciObjectTable: FunctionComponent<React.PropsWithChildren<IRadniSastanciObjectTableProps>> = (props) => {
  const dialogContext = useContext<DialogContextType>(DialogContext);
  const { t } = useTranslation();
  const { records, onRowSelect, onSave, model, titleToken, rowSelectedCustom, onCloseDialog, refreshRecords, statusFields, selectedLokacija } = props;

  // const [records, setRecords] = useState<DCRecord[]>([]);
  const [filteredRecords, setFilteredRecords] = useState<DCRecord[]>([]);
  const [zapisnikDl, setZapisnikDl] = useState<{id: number}>({id: 0});
  const [rowSelected, setRowSelected] = useState<DCRecord|null>(null);
  const [globalFilter, setGlobalFilter] = useState<string|undefined>();

  const dc: IDataController = new dataController(model);

  const locationField = "id";

  // useEffect(() => {
  //   refreshRecords();
  // }, []);

  useEffect(() => {
    const { id } = zapisnikDl;
    if (id === 0) {
      // do error logging
      return;
    }
    const record = records.find(r => r.id === id);
    if (!record) {
      // do error logging
      return;
    }
    const koName = record.obv ? record.obv : "";
    const apiInstance = new api();
    const path = `${model.apiPath}/${id}/zapisnik?ko_name=${koName}`;
    downloadFile(path, undefined, `${koName}-${id}.pdf`);
    // apiInstance.Download(path).then((file: unknown) => {
    //   console.log("GOT FILE:");
    //   console.log(file);
    // })

  }, [zapisnikDl]);

  // const refreshRecords = () => {
  //   loaderContext.toggleLoading(true);
  //   dc.GetData()
  //     .then((resp) => {
  //       if (resp.success && Array.isArray(resp.data)) {
  //         const rs = resp.data.map(r => ({...r, ...{ zapisnik_dl: r.zap === '1' ? true : false }}))
  //         setRecords(rs)
  //         setFilteredRecords(rs)
  //         if (resp.data.length === 0) {
  //           snackbarContext.showNotification("messages.nodata", "warning", true);
  //         }
  //       };
  //     })
  //     .catch((resp) => {
  //       console.log(resp);
  //     })
  //     .finally(() => {
  //       loaderContext.toggleLoading(false);
  //     });
  // };

  const handleRowSelect = (id: number) => {
    if (rowSelected === null)
      CHANGED_FLAG = true;
      const record = records.find(r => r.id === id);
    if (record !== undefined) {
      const [rLok, rId] = rowSelected === null ? [-1, -1] : [rowSelected[locationField], rowSelected.id];
      if (record.id === rId && record[locationField] === rLok) {
        setRowSelected(null);
        onRowSelect(Number(record[locationField]), record);
      } else if (record.id !== rId && record[locationField] === rLok) {
        setRowSelected(record);
      }else {
        setRowSelected(record);
        onRowSelect(Number(record[locationField]), record);
      }
    } else {
      setRowSelected(null);
    }
  }

  const handleRowAction = (action: string, id: number, record?: { [key: string]: any }) => {
    switch(action) {
      case 'show_katovi':
        if(id) {
          const dcKatovi = new dataController(modelKatovi, 'operations/objekti/' + id + '/katovi-namjene');
          const dcDijelovi = new dataController(modelDijelovi);
          dcKatovi.GetData().then(resp => {
            // console.log(resp);
            if(resp && resp !== null && resp.success) {
              // Really ugly old solution:
                  // let katovi = resp.data;
                  // if(katovi && Array.isArray(katovi)) {
                  //   for(const kat in katovi) {
                  //     // Namjene: s=1, pos=5, g=3, pom=2, b=4, zem=11, nei=12, ostalo=8
                  //     // L_TODO: Seems inefficient, should be moved to backend
                  //     dcDijelovi.GetData('operations/objekti/' + id + '/katovi/' + katovi[kat].id + '/dijelovi').then(
                  //       resp => {
                  //         if(resp.success && Array.isArray(resp.data)) {
                  //           let tempFields = Array(12).fill(0);
                  //           for(const dio of resp.data) {
                  //             if(dio.namjena_id && dio.namjena_id !== null) {
                  //               tempFields[dio.namjena_id as number - 1] = (tempFields[dio.namjena_id as number - 1] as number) + (dio.pre_pb as number);
                  //               povrsina += (dio.pre_pb as number);
                  //             } else {
                  //               // Lack of data in dev database, what has no "namjena_id" or does not fit into 
                  //               // the designated table fields does not get added to surface area
                  //               // tempFields[7] = (tempFields[7] as number) + (dio.pre_pb as number);
                  //             }
                  //           }
                  //           // @ts-ignore
                  //           let tempRecord = { ...katovi[kat],
                  //             objekti_id:   record ? record.id as number : 0,
                  //             stambeno:     tempFields[0] as number,
                  //             poslovno:     tempFields[4] as number,
                  //             garazno:      tempFields[2] as number,
                  //             pomocno:      tempFields[1] as number,
                  //             balkoni:      tempFields[3] as number,
                  //             zemljiste:    tempFields[10] as number,
                  //             neizgradeno:  tempFields[11] as number,
                  //             ostalo:       tempFields[7] as number
                  //           }
                  //           recordsKatovi.push(tempRecord);
                  //         }
                  //       }
                  //     ).catch(resp => console.log(resp));
                  //   }
                  // }              
            
                const recordsKatovi = resp.data;
                
                if(recordsKatovi && recordsKatovi !== null && Array.isArray(recordsKatovi)) {
                    let povrsina = 0;
                  
                  for(let kat of recordsKatovi) {
                    povrsina += Number(kat.ukupna_povrsina);
                  }

                  dialogContext.showDialog(KatoviDialog, {
                    selectedObjekt: record ? record : null, 
                    katovi: recordsKatovi,
                    dc: dcKatovi,
                    povrsina: povrsina,
                    onSave: onSave,
                    onDialogClose: onCloseDialog
                  });
                }  
              }
          }).catch(resp => console.log(resp));
        }     
    }
  }

  const showStatusDialog = () => {
    dialogContext.showDialog(StatusDialog, {fields: statusFields});
  }

  // const handleGlobalFilterChange = (globalFilter: string | undefined) => {
  //   if (CHANGED_FLAG && !globalFilter) {
  //     CHANGED_FLAG = false
  //   } else {
  //     setGlobalFilter(globalFilter);
  //   }
  // }
  // useEffect(() => {
  //   console.log('Doing this');
  //   if (lokacijaId) {
  //     const fRecords: DCRecord[] = records.filter(r => r[locationField] === lokacijaId);
  //     // setFilteredRecords(fRecords);
  //     setFilteredRecords(records);
  //     if (fRecords.length > 0) {
  //       // setRowSelected(fRecords[0]);
  //       // if (onLoad) {
  //       //   onLoad(fRecords);
  //       // }
  //     } else {
  //       setRowSelected(null);
  //     }

  //   } else {
  //     setFilteredRecords(records);
  //     setRowSelected(null);
  //   }
  // }, [records, lokacijaId])

  // useEffect(() => {
  //   if (rowSelected !== null) {
  //     onRowSelect(Number(rowSelected[locationField]), rowSelected);
  //   }
  // }, [globalFilter]);

  return (
    <ModelTable
      title={t(titleToken)}
      records={records /** filteredRecords */}
      viewName="radni_sastanci"
      dc={dc}
      allowSelection="one"
      allowFilter={true}
      allowExport={true}
      allowAdd={false}
      allowEdit={false}
      disableControls={false}
      initialPageSize={25}
      onRowAction={handleRowAction}
      allowRowAction={() => { return true;}}
      onRowClick={handleRowSelect}
      unselectRow={true}
      rowSelectedCustom={rowSelectedCustom}
      onGlobalFilterChange={() => {/** handleGlobalFilterChange() */}}
      customRecordCount={records.length}
      gotoFirstPageOnSelect={false}
      allowInc={false}
      allowLegend={true}
      onLegendClick={showStatusDialog}
      legendLabel={t("common.namjena")}
      handleRefresh={refreshRecords}
      defaultGlobalFilter={(selectedLokacija?.id as number)?.toString()}
      trackTableState={true}
    />
  );
}

export default RadniSastanciObjectTable;
